import { type IAdminWithdrawalHistoryEntry } from '@mahawi/eshop-common/src/types';
import { type ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import React from 'react';

import { EDateFormat } from '../../fragments/date-format';
import TableComponent from '../table';
import WithdrawalStatusTag from './status-tag';

type THistoryRow = IAdminWithdrawalHistoryEntry & { key: string };

interface IHistoryTableProps {
  history: IAdminWithdrawalHistoryEntry[];
  currencyIsoCode: string | null;
}

function HistoryTable({
  history,
  currencyIsoCode,
}: IHistoryTableProps): React.ReactElement {
  const columns: ColumnsType<THistoryRow> = [
    {
      title: 'When',
      dataIndex: 'createdAt',
      render: (createdAt: string): string =>
        dayjs(createdAt).format(EDateFormat.DATE_TIME),
    },
    {
      title: 'Change',
      render: (_value: string, record: THistoryRow): React.ReactElement => (
        <>
          <WithdrawalStatusTag status={record.fromStatus} />→{' '}
          <WithdrawalStatusTag status={record.toStatus} />
        </>
      ),
    },
    {
      title: 'Staff',
      render: (_value: string, record: THistoryRow): string =>
        record.account.email,
    },
    { title: 'Note', dataIndex: 'note' },
    {
      title: 'Refunded',
      dataIndex: 'refundedAmount',
      render: (amount: number | null): string =>
        amount === null ? '' : `${amount} ${currencyIsoCode ?? ''}`.trim(),
    },
  ];

  return (
    <TableComponent
      columns={columns as Parameters<typeof TableComponent>[0]['columns']}
      dataSource={history.map((entry, index) => ({
        key: `${entry.createdAt}-${index}`,
        ...entry,
      }))}
      isLoading={false}
      emptyText="No status changes yet"
    />
  );
}

export default HistoryTable;
